import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Keyboard, Pagination, Navigation } from "swiper";

export default function Slider(props) {
    let additional_images = props.url.additional_images || props.additional_images || [];
    const updateSlideData = (s) => {
        if (!props.setAdditionalImagesData){
            return
        }

        if (s.activeIndex===0){
            props.setAdditionalImagesData({
                isSelected: false,
                idx: "",
            })
        }
        else {
            const image = additional_images[s.activeIndex - 1]
              props.setAdditionalImagesData({
                isSelected: true,
                idx: image.idx
            })
        }
        if (!props.setCurrentImageUrl){
            return
        }
        if (s.activeIndex===0){
            props.setCurrentImageUrl(props.primary_image)
        }
        else {
            const image = additional_images[s.activeIndex - 1]
            props.setCurrentImageUrl(image.image)
        }

    }
    return (
        <>
            <div className="my-custom-pagination-div" />
            <Swiper
                slidesPerView={1}
                spaceBetween={0}
                keyboard={{
                    enabled: true,
                }}
                pagination={{
                    el: '.my-custom-pagination-div',
                    clickable: true
                }}
                navigation={true}
                modules={[Keyboard, Pagination, Navigation]}
                className="mySwiper"
                grabCursor={true}
                centeredSlides={true}
                autoHeight={true}
                onSlideChange={(s) => updateSlideData(s)}
            >
                <SwiperSlide> 
                    <div style={{background: "#c3c3c3", aspectRatio: props?.url[0]?.cdata.primary_image_width / props?.url[0]?.cdata.primary_image_height}} className='swatch-image-container'>
                        <img style={{visibility: props.isLoading? "hidden":""}} onLoad={() => { props.setIsLoading(false) }} loading="lazy" alt="slide-1" src={props.primary_image} /> 
                    </div> 
                </SwiperSlide>
                {
                    additional_images.map((img, index) => <SwiperSlide key={img.id}> <div key={img.id} className='swatch-image-container'><img onLoad={() => { props.setIsLoading(false) }} loading="lazy" style={{visibility: props.isLoading? "hidden":""}} alt={"slide-" + (index + 2)} src={img.image} /> <div className="swiper-lazy-preloader"></div></div> </SwiperSlide>)
                }
            </Swiper>
        </>
    );
}